import { template as _$template } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=flight__controls-row data-testid=viewer-effects-row>`);
/**
 * VIEW AIRPLANES' toggle row: PROPELLER EFFECT, ENHANCED EFFECTS, ENHANCED
 * MODELS, on the same persisted `EffectsSettings` `/fly` writes (roadmap G15).
 *
 * ## Why it is an HTML row and not a widget on the 320x200 screen
 *
 * The screen itself is a pixel reproduction: `shell/model/plane-viewer-screens.ts`
 * measures its well, its four view arrows, its description plate and its
 * `PREVIOUS`/`NEXT`/`CONTINUE` row off the original's own capture, and every
 * row of those 200 lines is spoken for. There is no rect free for three
 * controls the original had no concept of — which is the identical argument
 * `flight/effects-settings.ts` already makes for keeping these off the Realism
 * Panel, and the identical answer: they live beside the screen, in the port's
 * own chrome, saying plainly what they are.
 *
 * ## Why these three and no more
 *
 * `EffectsSettings` has six members and three of them have nothing to decide
 * on a parked aeroplane: KILL CAMERA needs a kill, ENHANCED SKY needs a briefed
 * hour this screen has none of, and ENHANCED TERRAIN
 * decorates a campaign region rather than the practice range. Offering a
 * control that cannot change the picture in front of it would be worse than
 * not offering it.
 *
 * **ENHANCED EFFECTS is the honest edge case, and it is here anyway.** It gates
 * particle fire, smoke and hit sparks on a *damaged* aeroplane
 * (`flight/particle-effects.ts`), and nothing on this screen is damaged — so
 * unlike the other two it changes no pixel here today, and this file will not
 * pretend otherwise. It is on the row because the roadmap item names it and
 * because the three belong together as one persisted group: a pilot who sets it
 * here is setting it for the sortie he flies next, which is the same
 * cross-screen sharing that makes ENHANCED MODELS worth having on an inspection
 * screen at all. If it ever gains something to show on a parked aeroplane —
 * exhaust haze, a wind-stirred windsock — this is already where its switch is.
 */

import { EnhancedEffectsToggle, EnhancedModelsToggle, PropellerEffectToggle } from "../flight/EffectsToggles.tsx";
export function ViewerEffectsControls(props) {
  return (// The flight row's own class, reused rather than restyled: it is the same
    // control in the same corner of the same app, and a second stylesheet for
    // it is a second place for it to drift.
    (() => {
      var _el$ = _tmpl$();
      _$insert(_el$, _$createComponent(PropellerEffectToggle, {
        get settings() {
          return props.settings;
        },
        get onChange() {
          return props.onChange;
        }
      }), null);
      _$insert(_el$, _$createComponent(EnhancedEffectsToggle, {
        get settings() {
          return props.settings;
        },
        get onChange() {
          return props.onChange;
        }
      }), null);
      _$insert(_el$, _$createComponent(EnhancedModelsToggle, {
        get settings() {
          return props.settings;
        },
        get onChange() {
          return props.onChange;
        }
      }), null);
      return _el$;
    })()
  );
}